import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/handling-units')({
  beforeLoad: ({ context }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['tenants:manage', 'tenants:access-read-only'])
    ) {
      throw redirect({ to: '/settings' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/handling-unit-types/pages/handling-unit-types-page')),
});
